<template>
  <div class="row">
    <div class="col-ms-12">
      <b-button
        v-if="currentCampagne.statut == CONST.C_ATTENTE"
        variant="success"
        class="btn-icon mr-4"
        @click="updateStatut(CONST.C_CONFIRMER)"
      >
        <span class="btn-icon-label">
          <i class="fa fa-thumbs-up"></i>
        </span>
        Confirmé
      </b-button>
      <b-button
        v-if="currentCampagne.statut == CONST.C_ATTENTE"
        variant="danger"
        class="btn-icon mr-4"
        @click="updateStatut(CONST.C_REFUSER)"
      >
        <span class="btn-icon-label">
          <i class="fa fa-thumbs-down"></i>
        </span>
        Refusé
      </b-button>
      <b-button
        v-if="currentCampagne.statut == CONST.C_CONFIRMER"
        variant="success"
        class="btn-icon mr-4"
        @click="updateStatut(CONST.C_TERMINER)"
      >
        <span class="btn-icon-label">
          <i class="fa fa-thumbs-up"></i>
        </span>
        Terminé
      </b-button>
      <b-button
        v-if="currentCampagne.statut != CONST.C_ATTENTE"
        variant="warning"
        class="btn-icon mr-4"
        @click="updateStatut(CONST.C_ATTENTE)"
      >
        <span class="btn-icon-label">
          <i class="fa fa-hourglass"></i>
        </span>
        En attente
      </b-button>
    </div>
  </div>
</template>

<script>
import CONST from '@/constants/rh/entretien';
import URL from '@/http/rh/entretien/campagne-entretien';
export default {
  data() {
    return {
      CONST,
    };
  },
  methods: {
    updateStatut(statut) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.UPDATE_STATUT + '/' + this.$route.params.id + '/' + statut)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.$emit('onUpdateStatut');
              /**
               * this.$router
                .push({
                  name: 'rh_formation-show',
                  params: { id: this.currentFormation.id },
                })
                .catch(() => {});
               */
            })
            .catch();
        }
      });
    },
  },
  props: {
    currentCampagne: {
      require: true,
      type: Object,
    },
  },
};
</script>
